import React, { memo } from 'react';
import Close from '@mui/icons-material/Close';
import styles from './styles.module.scss';

/** White cross on red circle — destructive / proceed-with-care confirms (ROAR-4430). */
const ConfirmCrossIcon = () => (
  <div className={`${styles.error} flex items-center justify-center`}>
    <Close sx={{ fontSize: 36, color: '#fff' }} />
  </div>
);

export default memo(ConfirmCrossIcon);
